export default __webpack_public_path__ + "static/media/icons.425399f8.woff";